export default (theme) => ({
  tableWrapper: {
    padding: 15,
    maxHeight: 600,
    border: "1px solid #e0dcdc",
  }
});
